import { calcRemaining } from '../../../util/calcRemaining';

const amountRemaining = (total, spent) => parseFloat(calcRemaining(total, spent));

export const hasMoneyLeft = ({ value }, { transferFrom: { dept } }) =>
  value && parseFloat(dept.remainingAllotment) > 0 ? undefined : 'Department needs to have money available';

export const hasEnoughMoney = (value, { transferFrom }) =>
  value &&
  transferFrom &&
  transferFrom.dept &&
  transferFrom.dept.remainingAllotment &&
  amountRemaining(transferFrom.dept.remainingAllotment, value) >= 0
    ? undefined
    : 'Exceeds Amount Available';

export const overLockedAmt = (value, { transferFrom }) =>
  value &&
  transferFrom.dept &&
  transferFrom.dept.remainingAllotment &&
  (!parseFloat(transferFrom.dept.lockedAllotment) ||
    amountRemaining(transferFrom.dept.remainingAllotment, value) >=
      (parseFloat(transferFrom.dept.lockedAllotment) > parseFloat(transferFrom.dept.spentAllotment)
        ? parseFloat(transferFrom.dept.lockedAllotment) - parseFloat(transferFrom.dept.spentAllotment)
        : 0))
    ? undefined
    : `Locked Allotment: Minimum Allotment is ${transferFrom.dept.lockedAllotment}`;
